(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (function () {
    var SPEED = 70;

    function setup(bar) {
      var track = bar.querySelector('[data-announcement-track]');
      if (!track) return;

      bar.classList.remove('announcement-bar--marquee');
      var extras = track.querySelectorAll('.announcement-bar__item');
      for (var i = extras.length - 1; i > 0; i--) extras[i].remove();

      var item = track.querySelector('.announcement-bar__item');
      if (!item) return;

      var gap = 48;
      var copy = item.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      track.appendChild(copy);

      bar.style.setProperty('--announcement-gap', gap + 'px');
      bar.style.setProperty('--announcement-duration', Math.max(14, (item.scrollWidth + gap) / SPEED) + 's');
      bar.classList.add('announcement-bar--marquee');
    }

    function run() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-announcement-bar]'), setup);
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(run, 200);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(run);
    }

    document.addEventListener('shopify:section:load', function (event) {
      var bar = event.target.querySelector('[data-announcement-bar]');
      if (bar) setup(bar);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["candy-best-sellers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function slotSize(track, card) {
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function visibleCount(root) {
      var raw = window.getComputedStyle(root).getPropertyValue('--cbs-visible');
      var n = parseInt(raw, 10);
      return n > 0 ? n : 5;
    }

    function syncNav(root) {
      var viewport = root.querySelector('[data-cbs-viewport]');
      var cards = root.querySelectorAll('[data-cbs-card]');
      var prev = root.querySelector('[data-cbs-prev]');
      var next = root.querySelector('[data-cbs-next]');
      var canScroll = cards.length > visibleCount(root);
      if (prev) prev.disabled = !canScroll;
      if (next) next.disabled = !canScroll;
      if (viewport) viewport.style.overflowX = canScroll ? 'auto' : 'hidden';
    }

    function scrollByCard(root, direction) {
      var viewport = root.querySelector('[data-cbs-viewport]');
      var card = root.querySelector('[data-cbs-card]');
      var track = root.querySelector('[data-cbs-track]');
      if (!viewport || !card || !track) return;
      viewport.scrollBy({ left: direction * slotSize(track, card), behavior: 'smooth' });
    }

    function snapToCard(root) {
      var viewport = root.querySelector('[data-cbs-viewport]');
      var track = root.querySelector('[data-cbs-track]');
      var card = root.querySelector('[data-cbs-card]');
      if (!viewport || !track || !card) return;
      var size = slotSize(track, card);
      if (size <= 0) return;
      var maxIndex = Math.max(0, root.querySelectorAll('[data-cbs-card]').length - visibleCount(root));
      var index = Math.round(viewport.scrollLeft / size);
      if (index < 0) index = 0;
      if (index > maxIndex) index = maxIndex;
      viewport.scrollTo({ left: index * size, behavior: 'smooth' });
    }

    function canMouseDrag() {
      return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    }

    function enableDrag(root) {
      var viewport = root.querySelector('[data-cbs-viewport]');
      if (!viewport) return;

      var DRAG_THRESHOLD = 8;
      var activePointer = null;
      var dragging = false;
      var startX = 0;
      var startScroll = 0;
      var suppressClick = false;
      var suppressTimer = 0;

      function onPointerMove(event) {
        if (activePointer !== event.pointerId) return;
        var dx = event.clientX - startX;
        if (!dragging) {
          if (Math.abs(dx) < DRAG_THRESHOLD) return;
          dragging = true;
          viewport.classList.add('is-dragging');
          try { viewport.setPointerCapture(event.pointerId); } catch (err) {}
        }
        event.preventDefault();
        viewport.scrollLeft = startScroll - dx;
      }

      function endDrag(event) {
        if (activePointer === null) return;
        if (event && typeof event.pointerId === 'number' && event.pointerId !== activePointer) return;
        var didDrag = dragging;
        dragging = false;
        activePointer = null;
        viewport.classList.remove('is-pressing', 'is-dragging');
        window.removeEventListener('pointermove', onPointerMove);
        window.removeEventListener('pointerup', endDrag);
        window.removeEventListener('pointercancel', endDrag);
        if (!didDrag) return;
        suppressClick = true;
        window.clearTimeout(suppressTimer);
        suppressTimer = window.setTimeout(function () {
          suppressClick = false;
        }, 50);
        snapToCard(root);
      }

      viewport.addEventListener('pointerdown', function (event) {
        if (!canMouseDrag()) return;
        if (event.pointerType !== 'mouse') return;
        if (event.button !== 0) return;
        if (event.target.closest('[data-cbs-prev], [data-cbs-next], button, input, select, textarea')) return;
        activePointer = event.pointerId;
        dragging = false;
        startX = event.clientX;
        startScroll = viewport.scrollLeft;
        viewport.classList.add('is-pressing');
        window.addEventListener('pointermove', onPointerMove);
        window.addEventListener('pointerup', endDrag);
        window.addEventListener('pointercancel', endDrag);
      });

      viewport.addEventListener('dragstart', function (event) {
        event.preventDefault();
      });

      viewport.addEventListener('click', function (event) {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
      }, true);
    }

    function init(root) {
      if (!root || root.dataset.cbsReady === 'true') return;
      root.dataset.cbsReady = 'true';

      root.addEventListener('click', function (event) {
        if (event.target.closest('[data-cbs-prev]')) scrollByCard(root, -1);
        if (event.target.closest('[data-cbs-next]')) scrollByCard(root, 1);
      });

      enableDrag(root);
      syncNav(root);
      window.addEventListener('resize', function () { syncNav(root); });
    }

    function scan(scope) {
      (scope || document).querySelectorAll('[data-cbs]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { scan(); });
    } else {
      scan();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-cbs]');
      if (root) {
        root.dataset.cbsReady = '';
        init(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (function () {
    function initCarousel(root) {
      if (!root || !window.theme || !theme.peekCarousel) return;
      theme.peekCarousel.init(
        root,
        $('.js-cart-recommendations-carousel', root),
        '.cartRecommendations',
        function () {
          return $(window).width() < 768;
        },
        false
      );
    }

    function loadCartRecommendations() {
      var root = document.querySelector('[data-cart-recommendations]');
      if (!root || root.getAttribute('data-loaded') === 'true') return;
      var url = root.getAttribute('data-url');
      if (!url) return;

      fetch(url)
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var wrapper = document.createElement('div');
          wrapper.innerHTML = html;
          var fresh = wrapper.querySelector('[data-cart-recommendations]');
          if (!fresh || !fresh.querySelector('.product-block')) {
            root.remove();
            return;
          }
          root.innerHTML = fresh.innerHTML;
          root.setAttribute('data-loaded', 'true');
          if (window.lazySizes && lazySizes.loader) lazySizes.loader.checkElems();
          initCarousel(root);
          if (typeof window.applyHidePricesGuestBoxes === 'function') {
            window.applyHidePricesGuestBoxes(root);
          }
        })
        .catch(function () {
          root.remove();
        });
    }

    loadCartRecommendations();
    document.addEventListener('shopify:section:load', function (event) {
      if (event.target && event.target.querySelector('[data-cart-recommendations]')) {
        loadCartRecommendations();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-more-from-vendor"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('.product-vendor-more');
  if (!root || !window.theme || !theme.peekCarousel) return;

  theme.peekCarousel.init(
    root,
    $('.js-more-from-brand-carousel', root),
    '.productMoreFromBrand',
    function () {
      return $(window).width() < 768;
    },
    false,
    {
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 2,
      swipeToSlide: true,
      dots: false,
      arrows: false
    }
  );

  if (typeof window.applyHidePricesGuestBoxes === 'function') {
    window.applyHidePricesGuestBoxes(root);
  }
});

document.addEventListener('shopify:section:load', function (event) {
  var root = event.target && event.target.querySelector('.product-vendor-more');
  if (!root || !window.theme || !theme.peekCarousel) return;
  theme.peekCarousel.init(
    root,
    $('.js-more-from-brand-carousel', root),
    '.productMoreFromBrand',
    function () {
      return $(window).width() < 768;
    },
    false,
    {
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 2,
      swipeToSlide: true,
      dots: false,
      arrows: false
    }
  );
  if (typeof window.applyHidePricesGuestBoxes === 'function') {
    window.applyHidePricesGuestBoxes(root);
  }
});

document.addEventListener('shopify:section:unload', function (event) {
  if (!event.target || !window.theme || !theme.peekCarousel) return;
  theme.peekCarousel.destroy(
    $('.product-vendor-more', event.target),
    $('.js-more-from-brand-carousel', event.target),
    '.productMoreFromBrand'
  );
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

      theme.peekCarousel.init(
        productRecommendationsSection,
        $('.js-related-product-carousel', productRecommendationsSection),
        '.productRecommendations',
        function() {
          return $(window).width() < 768
        },
        false,
        {
          infinite: false,
          slidesToShow: 2,
          slidesToScroll: 2,
          swipeToSlide: true,
          dots: false,
          arrows: false
        }
      );

      if (typeof window.applyHidePricesGuestBoxes === 'function') {
        window.applyHidePricesGuestBoxes(productRecommendationsSection);
      }
    }
  };
  request.send();
};
// Reload the section in the editor when a setting changes
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
document.addEventListener("shopify:section:unload", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    theme.peekCarousel.destroy(
      $('.product-recommendations', event.target),
      $('.js-related-product-carousel', event.target),
      '.productRecommendations'
    );
  }
});
// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();
})();
